import React from 'react';
import EntityButton from '../UI/EntityButton';

const TabBar = ({
  active,
  setActive,
  resetHandler,
  tabItems
}) => {
  
  const chooseEntityHandler = value => {
    if (value !== active) {
      resetHandler && resetHandler();
      setActive(value);
    }
  }

  return (
    <div className="tab-bar">
      <div className="tab-bar-entity-wrap">
        {tabItems.map(item => {
          return (
            <EntityButton 
              key={item.label}
              label={item.label}
              value={item.value}
              styles={active === item.value ? "Active" : ""}
              chooseEntityHandler={chooseEntityHandler}
            />
          )
        })}
      </div>
    </div>  
  )
}

export default TabBar;